<template>
  <div class="documentation-detail">
        <h1 class="title">{{detail.title}}</h1>
        <p class="sub-title">
          <span><i class="iconfont icon-caijishijian"></i>发布时间：{{detail.createTime}}</span>
          <span><i class="iconfont icon-caijishijian"></i>发布人：{{detail.username}}</span>
        </p>
        <div class="documentation-content" v-html="detail.content"> </div>
  </div>
</template>

<script>
    export default {
        data(){
            return {
                detail: {}
            }
        },
        mounted(){
            this.getAnnouncementDetail()
        },
        methods: {
            // async getAnnouncementDetail(){
            //     let { id } = this.$store.state.docStore.documentation
            //     let result = await this.$http.post('api/help/Id', { id })
            //     if(result){
            //         console.log( result )
            //         this.detail = result;
            //     }
            // }
            toDetail(item){
            this.$store.commit('documentationData', {
                componentName: 'documentDetail',
                id: item.areaCode
            })
        }
        }
    }
</script>

<style lang="scss" scoped>
    .documentation-detail{
        background: white;
        margin-left: 16.7%;
        margin-right: 20px;
        margin-top: 20px;
        border-top: 1px solid transparent;
        padding: 20px;
        padding-top:0;
        .title{
            font-size: 14px;
            font-weight: normal;
            line-height: 56px;
            height: 56px;
        }
        .sub-title{
            font-size: 12px;
            color: #666666;
            border-bottom:1px solid #cccccc;
            padding-bottom:10px;
            span{
                padding-right: 20px;
                i{
                    margin-right:9px;
                    vertical-align: middle
                }
            }
        }
        .documentation-content{
           padding: 10px 0;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/documentation/detail.vue